if (!window.customElements.get('friends-collection-footer')) {
  class FriendsCollectionFooter extends HTMLElement {
    connectedCallback() {
      this.description = this.querySelector('[data-collection-description]');
      this.toggle = this.querySelector('[data-collection-description-toggle]');

      if (!this.description || !this.toggle) {
        return;
      }

      this.boundToggle = this.boundToggle || this.handleToggle.bind(this);
      this.boundUpdateOverflowState = this.boundUpdateOverflowState || this.updateOverflowState.bind(this);
      this.toggle.addEventListener('click', this.boundToggle);
      this.setAttribute('data-ready', '');

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.boundUpdateOverflowState);
        this.resizeObserver.observe(this.description);
      } else {
        window.addEventListener('resize', this.boundUpdateOverflowState);
      }

      requestAnimationFrame(this.boundUpdateOverflowState);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.boundToggle);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.boundUpdateOverflowState);
    }

    handleToggle() {
      const willExpand = !this.hasAttribute('expanded');

      this.toggleAttribute('expanded', willExpand);
      this.toggle.setAttribute('aria-expanded', String(willExpand));
      this.toggle.textContent = willExpand ? this.toggle.dataset.showLess : this.toggle.dataset.showMore;

      if (!willExpand) {
        requestAnimationFrame(() => this.updateOverflowState());
      }
    }

    updateOverflowState() {
      if (this.hasAttribute('expanded')) {
        return;
      }

      const isOverflowing = this.description.scrollHeight > this.description.clientHeight + 1;
      this.toggleAttribute('data-overflowing', isOverflowing);
      this.toggle.hidden = !isOverflowing;
    }
  }

  window.customElements.define('friends-collection-footer', FriendsCollectionFooter);
}
